<template>
    <div class="main">
        <header class="flex">
            <!-- <el-radio-group v-model="radio1" size="small">
                <el-radio-button label="written">已写</el-radio-button>
                <el-radio-button label="notWritten">未写</el-radio-button>
            </el-radio-group> -->
            <div>
                <el-select v-model="projectId" placeholder="请选择服务类型" class="mr10" size="small" filterable clearable>
                    <el-option v-for="(item,index) in serviceTypeList" :label="item.serviceType" :value="item.id"  :key="index"></el-option>
                </el-select>
                <el-input v-model="serviceName" style="margin: 0 20px;" size="small" placeholder="请输入服务名称"></el-input>
                <el-button @click="getDetailList" type="primary" size="small">查询</el-button>
            </div>


        </header>

        <div class="table_box">
            <el-table
                stripe
                border
                :data="detailList"
                style="width: 100%"
                id="table"
                size="small"
            >
                <el-table-column
                header-align="center"
                align="center"
                type="index"
                size="small"
                label="序号"
                :index="(index) => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="serviceSn"
                label="预约单号"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="客户名称"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="serviceType"
                label="类型"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="serviceName"
                label="服务"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="服务技师"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                label="操作图片"          
                >
                <template slot-scope="scope">
                    <el-image 
                        style="width: 100px; height: 100px"
                       
                        :src="scope.row.serviceStaffFeedbackImg[0]" 
                        :preview-src-list="scope.row.serviceStaffFeedbackImg">
                    </el-image>
                    <!-- <el-image 
                        style="width: 100px; height: 100px"
                        v-for="(v, i) in scope.row.serviceStaffFeedbackImg"
                        :key="i"
                        :src="v" 
                        :preview-src-list="scope.row.serviceStaffFeedbackImg">
                    </el-image> -->
                </template>
                
                </el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="serviceStaffFeedbackDescribe"
                label="服务细节"          
                ></el-table-column>
                <el-table-column
                header-align="center"
                align="center"
                prop="serviceStaffFeedbackTime"
                label="记录时间"          
                ></el-table-column>
            </el-table>

        </div>

        <div class="hm-pagination mb20">
            <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChanges"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
            ></el-pagination>
        </div>



    </div>
</template>

<script>
export default {
    data(){
        return {
            serviceTypeList:[],
            total:0,
            currentPage: 1,
            pageSize: 10,
            projectId:'',
            radio1: '上海',
            serviceName:'',
            detailList:[]
        }
    },

    created(){
        this.getDetailList();
        this.queryServiceRestorationTypeList();
    },
    methods: {
        async queryServiceRestorationTypeList() {
            const { result } = await this.$store.dispatch(
                "queryServiceRestorationTypeList",
                {}
            );
            // console.log("result:", result);
            if (result) {
                this.serviceTypeList = result;
            }
        }, 
        async getDetailList(){
           const { result } = await this.$store.dispatch('queryApplyRecordStaffFeedbackPage',{
                projectId: this.projectId,
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                serviceName: this.serviceName
            })
            const { records, total } = result;

            records.forEach(v => {
                if(typeof v.serviceStaffFeedbackImg === 'string' && v.serviceStaffFeedbackImg.includes(',')){
                    v.serviceStaffFeedbackImg = v.serviceStaffFeedbackImg.split(',')
                } else {
                    v.serviceStaffFeedbackImg = [v.serviceStaffFeedbackImg]
                }
            });
           
            this.detailList = records;

            this.total = total;
            console.log(result)
        },
        paging(page) {
            this.currentPage = page;
            this.getDetailList();
        },
        handleSizeChanges(size) {
            this.currentPage = 1;
            this.pageSize = size;
            this.getDetailList();
        },
    }
}



</script>



<style lang="scss" scoped>
.flex {
    display: flex;
    align-items: center;
    justify-content: end;
}

.main {
    background: #ffffff;
    padding: 20px;
    .table_box {
        margin-top: 20px;
    }
}

</style>


